export default "__VITE_ASSET__c09f76ae__"